import React from 'react';
import moment from 'moment';
import { Modal, DatePicker, Select } from 'antd';
import { injectIntl } from 'react-intl';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import icon from '~components/_common/icon/icon';
import translate from '~src/i18n/translate';
import data from './data';
import { appLog } from '~src/utils/log';

const { Option } = Select;

const options = data.map((item) => {
  return (
    <Option key={item.key} value={item.email}>
      {item.email}
    </Option>
  );
});

function recipientSelected(value) {
  appLog('recipientSelected -> value', Object.keys(value).length);
  appLog(`selected ${value}`);
}

function onChange(value, dateString) {
  appLog('Selected Time: ', value);
  appLog('Formatted Selected Time: ', dateString);
}

function onOk(value) {
  appLog('onOk: ', value);
}

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment();
}

// TODO: need to fix the limiter for the current time
// function range(start, end) {
//   const result = [];
//   for (let i = start; i < end; i++) {
//     result.push(i);
//   }
//   console.log('range -> result', result);
//   return result;
// }
// function disabledDateTime() {
//   const currentHour = parseInt(moment().format('H'), 10) + 1;
//   return {
//     disabledHours: () => range(0, currentHour).splice(1, 24),
//   };
// }

const ShareModal = ({ state, clicked, intl }) => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);

  const style = {
    container: {},
    titleBtn: {
      color: theme.colors.secondary,
      fontSize: '20px',
    },
    closeBtn: {
      color: theme.colors.darkGray,
      marginTop: '18px',
      fontSize: '20px',
      transition: '0.3s',
    },
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}>
          {icon('far', 'share-square', style.titleBtn)}
          {translate('send-share-link')}
        </div>
      }
      centered
      visible={state}
      onOk={clicked}
      onCancel={clicked}
      okText={translate('send')}
      cancelText={translate('cancel')}
      closeIcon={icon('far', 'times', style.closeBtn, 'close')}
      width={420}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <b>{translate('link-valid-until')}</b>
        <DatePicker
          format="DD/MM/YYYY - HH:mm"
          disabledDate={disabledDate}
          // disabledTime={disabledDateTime}
          showTime
          onChange={onChange}
          onOk={onOk}
          style={{
            width: '50%',
            margin: '4px 0px 15px -1px',
          }}
        />
        <b>{translate('send-link-to')}</b>
        <Select
          mode="tags"
          style={{ width: '100%' }}
          onChange={recipientSelected}
          tokenSeparators={[',']}>
          {options}
        </Select>
      </div>
    </Modal>
  );
};

export default injectIntl(ShareModal);
